import React from 'react';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';
var querystring = require('querystring');
import axios from 'axios';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Footer2Component from "../commons/footer2";


const PREMIUM_PRICE = 29.99
const PREMIUM_YEAR_PRICE = 19.99

export default class CompaniesPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            first_name_lead: '',
            last_name_lead: '',
            email_name_lead: '',
            title_name_lead: '',
            part_name_lead: '',
            subscrible_name_lead: 0,
            errors: {},
            menuShow: false,
            price_month: 0, // there are 2 value (0, 1)
        }
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        window.location = link;
    }

    mouseLinkTrustpilotClick = (evt) => {
        window.open('https://www.trustpilot.com/review/versity.co',"_blank");
    }

    handleChangePrice = (month, evt) => {
        this.setState({price_month: month})
    }

    render() {

		if (isMobile) {
            return (
                <div className="companies_boxx" id="v-companies_mobile">
                    <div className={"block-001 row mr0"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/home2/m-logo.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                        <div className="col-xs-12 text-center t-content">
                            <h2>Unlock Breakthrough<br/>Solutions with<br/>University Talent</h2>
                            <p>Access innovative, analytical, and technical solutions from top student problem solvers.</p>
                            <a className="btn" href="/signup">Get Started</a>
                        </div>
                        <img className="img_logo_bg cls-image-line" src={"/static/img/homeimg/home2/img-01-line.png"}/>
                    </div>
                    <div className="row main-content popular-services">
                        <span className="top-title">Popular Projects</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <ul className="pills-list__list pills-list--mobile">
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Market Research
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Competitive Analysis
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        User Experience Testing
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Website Security Review
                                    </a>
                                </li>
                            </ul>
                            <a href="/projects/browse"
                               className="pills-list__see-more">
                                See all projects
                            </a>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content how-work">
                        <span className="top-title">How it works</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-1">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 1</span>
                                    <div className="content">
                                        Post a project for your business that students could complete.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-2">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 2</span>
                                    <div className="content">
                                        Students from various universities engage with your projects to prove they are a fit for your company.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-3">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 3</span>
                                    <div className="content">
                                        Use Versity’s chat and milestones feature to communicate and track progress.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-4">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 4</span>
                                    <div className="content">
                                        Receive students’ work and provide feedback for student portfolios.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper">
                        <div className="logos">
                            <div className="logo logo-1">&nbsp;</div>
                            <div className="logo logo-2">&nbsp;</div>
                            <div className="logo logo-3">&nbsp;</div>
                            <div className="logo logo-4">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row pricing-wrapper pd0 mg0">
                        <div className="pricing">
                            <span className="title">Pricing</span>
                            <span className="sub-title">Choose the offering that works best for you</span>
                            <div className="main-block">
                                <span className="basic">&nbsp;</span>
                                <div className="choose-month-year d-flex mb-15"><span onClick={this.handleChangePrice.bind(this, 1)} className={this.state.price_month === 1? "btn btn-primary mr-5" : "btn btn-default mr-5" }>Monthly</span><span onClick={this.handleChangePrice.bind(this, 0)} className={this.state.price_month === 1? "btn btn-default ml-5" : "btn btn-primary ml-5"}>Annual</span></div>
                                <span className="free">${this.state.price_month === 1 ? PREMIUM_PRICE : PREMIUM_YEAR_PRICE}</span>
                                <span className="btn-business">BUSINESS</span>
                                <div className="contents">
                                    <div className="s-15">&nbsp;</div>
                                    <span className="c-1">
                                        <div className="display-flex">
                                            <i className="fa fa-check no-margin" aria-hidden="true"></i>
                                            <div className="p-regular"><strong>Unlimited</strong> Projects</div>
                                        </div>
                                        Access to 4,000 + Higher Education Institutions<br/>
                                        Project Management Tools<br/>
                                        Branded Company Profile
                                    </span>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <a href="/employers/signup" className="btn btn-signup">SIGN UP</a>
                            </div>
                            <div className="main-block hide-el">
                                <span className="basic">Premium</span>
                                <span className="free">$29.99 / month</span>
                                <span className="btn-business">BUSINESS POWER USERS</span>
                                <div className="contents">
                                    <div className="s-15">&nbsp;</div>
                                    <span className="c-1">
                                        <div className="display-flex">
                                            <i className="fa fa-check" aria-hidden="true"></i>
                                            <div className="p-regular"><strong>Unlimited</strong> Industry or Experiential<br/> Project Matches</div>
                                        </div>
                                        All Basic Features<br/>
                                        Dedicated Account Manager<br/>
                                        Talent Pool Reporting & Tracking<br/>
                                        Featured Profile in Search Results<br/>
                                        & Recommendations<br/>
                                        Dedicated Client Success Associate
                                    </span>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="s-30">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-testimonies">
                        <div className="testimonies">
                            <div className="mask w-slider-mask" id="w-slider-mask-0">
                                <div className="slider-testimony-box w-slide" aria-label="2 of 3" role="group">
                                    <div className="testimony-wrapper">
                                        <div className="testimony-text">
                                            <img src="/static/img/homeimg/companies/img-quote.png" alt="" className="image-8"/>
                                            <div className="s-20 _w-30">&nbsp;</div>
                                            <p className="p-regular text-left">Versity projects are a great way for students to showcase their abilities, skills and creative ideas through innovative projects hosted by the employer. This is definitely the way of the future </p>
                                        </div>
                                        <div className="_w-30 s-30">&nbsp;</div>
                                        <div className="testimony-person width-full">
                                            <div className="avatar avatar-square company-logo logo-company-2">&nbsp;</div>
                                            <div className="s-20">&nbsp;</div>
                                            <div className="testimony-name">
                                                <div className="h5-medium dark-gray">Josue Sejour</div>
                                                <div className="p-regular "><em>Founder<br/></em>Sejour Group</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-benefits">
                        <div className="benefits">
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Generate Fresh Insights &amp; Ideas</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Discover, Attract &amp; Recruit Talent</div>
                                </div>
                            </div>
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Elevate Your Employer Brand</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Shape Our Future Workforce</div>
                                </div>
                            </div>
                            <div className="w-layout-grid grid-11">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-trustpilot">
                        <div className="trustpilot">
                            <div className={"trustpilot-title"}><img className={"stars-top"} alt="TrustScore: 0" src="/static/img/homeimg/stars/stars-0.png"/>Trustpilot</div>
                            <div className="row___2lDHR">
                                <div>
                                    <div className="starSelector___a7qui">
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="1" className="star___1E2ff" aria-label="1 star: Bad" data-star-selector-star-1="true" tabIndex="0"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="2" className="star___1E2ff" aria-label="2 stars: Poor" data-star-selector-star-2="true" tabIndex="-1"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="3" className="star___1E2ff" aria-label="3 stars: Average" data-star-selector-star-3="true" tabIndex="-1"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="4" className="star___1E2ff" aria-label="4 stars: Great" data-star-selector-star-4="true" tabIndex="-1"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="5" className="star___1E2ff" aria-label="5 stars: Excellent" data-star-selector-star-5="true" tabIndex="-1"/>
                                    </div>
                                    <div className="starRating___2Qn5z large___3x4yz">
                                        <img className={"stars"} alt="TrustScore: 5" src="/static/img/homeimg/stars/stars-5.svg"/>
                                    </div>
                                </div>
                            </div>
                            <div className={"trustpilot-value"}><span>3.8</span> out of 5</div>
                        </div>
                    </div>
                    <div className="logos-wrapper-new press-logos">
                        <div className="logos logos-news">
                            <div className="logo logo-press-1">&nbsp;</div>
                            <div className="logo logo-press-2">&nbsp;</div>
                            <div className="logo logo-press-3">&nbsp;</div>
                        </div>
                    </div>
                    <div className="row any-question mr0">
                        <div className="main-content">
                            <span className="top-title">Any questions? We are here to help</span>
                            <div className="div-block-101">
                                <div className="row pd0">
                                    <div className="col-xs-12 content">
                                        <span className="title">What is a project?</span>
                                        <div className="content">
                                            Projects are short-term, professional assignments that are similar to those given to new hires. These projects enable students to demonstrate skills, explore career paths, and build their networks as they seek the right full-time role. Unlike traditional internships, projects can take place year-round, and are due between one week and three months after kick-off. Projects are used by companies ranging from those in the Fortune 100 to emerging start-ups, and go across departments including sales, marketing, technology, HR, and finance.
                                        </div>
                                    </div>
                                    <div className="col-xs-12 content">
                                        <span className="title">How does this differ from an internship?</span>
                                        <div className="content">
                                            Versity is different than an internship platform in three main respects: 1) nearly all projects are virtual; 2) student's work is project-based; and 3) Internship engagements have a much more significant commitment with limited flexibility. Internships tend to last least weeks, are timed around the academic calendar, and require significant oversight to plan and manage. Since each student is expected to have the expertise to successfully complete the projects on their own, clients do not need to provide the support typical for an intern.
                                        </div>
                                    </div>
                                </div>
                                <div className="row pd0">
                                    <div className="col-xs-12 content">
                                        <span className="title">Can I hire the students after working with them?</span>
                                        <div className="content">
                                            Absolutely. Most students are enrolled in an academic program, and will be seeking either post-graduation employment or summer positions. You can reach out to any student you worked with who you were impressed by with job opportunities.
                                        </div>
                                    </div>
                                    <div className="col-xs-12 content">
                                        <span className="title">Who at the company engages and works with Versity?</span>
                                        <div className="content">
                                            Versity works directly with hiring managers across departments as well as human resources for company-wide campus recruiting programs. Many department heads use Versity to get work done on-demand while building a talent pipeline for sales, marketing, finance, operations, and just about every other department. Furthermore, since the students are highly skilled and have the experience or completed the prerequisite coursework to prepare them to execute these projects, companies do not need to provide managerial oversight or control.
                                        </div>
                                    </div>
                                </div>
                                <div className="t-footer">
                                    <div className="content">
                                        <a className="btn" href="/signup">Get Started</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer2Component isSlash={true}/>
                </div>
            )
        }

        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </header>
                <div id="v-companies" className="splash_wrapper companies_boxx">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div className="t-header">
                                <div className="content">
                                    <h1 className="title">Unlock Breakthrough Solutions with University Talent</h1>
                                    <span className="sub-title">
                                        Access innovative, analytical, and technical solutions from top student problem solvers.
                                    </span>
                                </div> 
                            </div>
                            <div className="t-footer">
                                <div className="content">
                                    <a className="btn" href="/signup">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row main-content popular-services">
                        <span className="top-title">Popular Projects</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <ul className="pills-list__list">
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Market Research
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Competitive Analysis
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        User Experience Testing
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Website Security Review
                                    </a>
                                </li>
                            </ul>
                            <a href="/projects/browse"
                               className="pills-list__see-more">
                                See all projects
                            </a>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content how-work">
                        <span className="top-title">How it works</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <div className="to-do-left col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-1">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 1</span>
                                <div className="content">
                                    Post a project for your business that students could complete.
                                </div>
                            </div>
                            <div className="to-do-middle col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-2">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 2</span>
                                <div className="content">
                                    Students from various universities engage with your projects to prove they are a fit for your company.
                                </div>
                            </div>
                            <div className="to-do-right col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-3">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 3</span>
                                <div className="content">
                                    Use Versity’s chat and milestones feature to communicate and track progress.
                                </div>
                            </div>
                            <div className="to-do-right col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-4">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 4</span>
                                <div className="content">
                                    Receive students’ work and provide feedback for student portfolios.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper">
                        <div className="logos">
                            <div className="logo logo-1">&nbsp;</div>
                            <div className="logo logo-2">&nbsp;</div>
                            <div className="logo logo-3">&nbsp;</div>
                            <div className="logo logo-4">&nbsp;</div>
                            <div className="logo logo-5">&nbsp;</div>
                            <div className="logo logo-6">&nbsp;</div>
                            <div className="logo logo-7">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-testimonies">
                        <div className="testimonies">
                            <div className="mask w-slider-mask" id="w-slider-mask-0">
                                <div className="slider-testimony-box w-slide" aria-label="2 of 3" role="group">
                                <div className="testimony-wrapper">
                                    <div className="testimony-person width-full">
                                        <div className="avatar avatar-square company-logo logo-company-2">&nbsp;</div>
                                        <div className="s-20">&nbsp;</div>
                                        <div className="testimony-name">
                                            <div className="h5-medium dark-gray">Josue Sejour</div>
                                            <div className="p-regular "><em>Founder<br/></em>Sejour Group</div>
                                        </div>
                                    </div>
                                    <div className="_w-30 s-30">&nbsp;</div>
                                    <div className="testimony-text">
                                        <img src="/static/img/homeimg/companies/img-quote.png" alt="" className="image-8"/>
                                        <div className="s-20 _w-30">&nbsp;</div>
                                        <p className="p-regular text-left">Versity projects are a great way for students to showcase their abilities, skills and creative ideas through innovative projects hosted by the employer. This is definitely the way of the future </p>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-benefits">
                        <div className="benefits">
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Generate Fresh Insights &amp; Ideas</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Discover, Attract &amp; Recruit Talent</div>
                                </div>
                            </div>
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Elevate Your Employer Brand</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Shape Our Future Workforce</div>
                                </div>
                            </div>
                            <div className="w-layout-grid grid-11">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-trustpilot">
                        <div className="trustpilot">
                            <div className={"trustpilot-title"}><img className={"stars-top"} alt="TrustScore: 0" src="/static/img/homeimg/stars/stars-0.png"/>Trustpilot</div>
                            <div className="row___2lDHR">
                                <div>
                                    <div className="starSelector___a7qui">
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="1" className="star___1E2ff" aria-label="1 star: Bad" data-star-selector-star-1="true" tabIndex="0"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="2" className="star___1E2ff" aria-label="2 stars: Poor" data-star-selector-star-2="true" tabIndex="-1"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="3" className="star___1E2ff" aria-label="3 stars: Average" data-star-selector-star-3="true" tabIndex="-1"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="4" className="star___1E2ff" aria-label="4 stars: Great" data-star-selector-star-4="true" tabIndex="-1"/>
                                        <input type="radio" onClick={this.mouseLinkTrustpilotClick.bind(this)} name="star-selector" value="5" className="star___1E2ff" aria-label="5 stars: Excellent" data-star-selector-star-5="true" tabIndex="-1"/>
                                    </div>
                                    <div className="starRating___2Qn5z large___3x4yz">
                                        <img className={"stars"} alt="TrustScore: 5" src="/static/img/homeimg/stars/stars-5.svg"/>
                                    </div>
                                    <div className={"trustpilot-value"}><span>3.8</span> out of 5</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="logos-wrapper-new press-logos">
                        <div className="logos logos-news">
                            <div className="logo logo-press-1">&nbsp;</div>
                            <div className="logo logo-press-2">&nbsp;</div>
                            <div className="logo logo-press-3">&nbsp;</div>
                            <div className="logo logo-press-4">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row pricing-wrapper">
                        <div className="pricing">
                            <span className="title">Pricing</span>
                            <span className="sub-title">Choose the offering that works best for you</span>
                            <div className="main-block mt60">
                                <span className="basic">&nbsp;</span>
                                <div className="choose-month-year d-flex mb-15"><span onClick={this.handleChangePrice.bind(this, 1)} className={this.state.price_month === 1? "btn btn-primary mr-5" : "btn btn-default mr-5" }>Monthly</span><span onClick={this.handleChangePrice.bind(this, 0)} className={this.state.price_month === 1? "btn btn-default ml-5" : "btn btn-primary ml-5"}>Annual</span></div>
                                <span className="free">${this.state.price_month === 1 ? PREMIUM_PRICE : PREMIUM_YEAR_PRICE}</span>
                                <span className="btn-business">BUSINESS</span>
                                <div className="contents">
                                    <div className="s-15">&nbsp;</div>
                                    <span className="c-1">
                                        <div className="display-flex">
                                            <i className="fa fa-check no-margin" aria-hidden="true"></i>
                                            <div className="p-regular"><strong>Unlimited</strong> Projects</div>
                                        </div>
                                        Access to 350 + Higher Education Institutions<br/>
                                        Project Management Tools<br/>
                                        Branded Company Profile
                                    </span>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <a href="/employers/signup" className="btn btn-signup">SIGN UP</a>
                            </div>
                            <div className="main-block mt23 hide-el">
                                <span className="basic">Premium</span>
                                <span className="free">$29.99 / month</span>
                                <span className="btn-business">BUSINESS POWER USERS</span>
                                <div className="contents">
                                    <div className="s-15">&nbsp;</div>
                                    <span className="c-1">
                                        <div className="display-flex">
                                            <i className="fa fa-check" aria-hidden="true"></i>
                                            <div className="p-regular"><strong>Unlimited</strong> Industry or Experiential<br/> Project Matches</div>
                                        </div>
                                        All Basic Features<br/>
                                        Dedicated Account Manager<br/>
                                        Talent Pool Reporting & Tracking<br/>
                                        Featured Profile in Search Results<br/>
                                        & Recommendations<br/>
                                        Dedicated Client Success Associate
                                    </span>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="s-30">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div className="row any-question">
                        <div className="s-60 s-40">&nbsp;</div>
                        <div className="main-content">
                            <span className="top-title">Any questions? We are here to help</span>
                            <div className="s-30">&nbsp;</div>
                            <div className="div-block-101">
                                <div className="row">
                                    <div className="col-xs-6 content">
                                        <span className="title">What is a project?</span>
                                        <div className="content">
                                            Projects are short-term, professional assignments that are similar to those given to new hires. These projects enable students to demonstrate skills, explore career paths, and build their networks as they seek the right full-time role. Unlike traditional internships, projects can take place year-round, and are due between one week and three months after kick-off. Projects are used by companies ranging from those in the Fortune 100 to emerging start-ups, and go across departments including sales, marketing, technology, HR, and finance.
                                        </div>
                                    </div>
                                    <div className="col-xs-6 content">
                                        <span className="title">How does this differ from an internship?</span>
                                        <div className="content">
                                            Versity is different than an internship platform in three main respects: 1) nearly all projects are virtual; 2) student's work is project-based; and 3) Internship engagements have a much more significant commitment with limited flexibility. Internships tend to last least weeks, are timed around the academic calendar, and require significant oversight to plan and manage. Since each student is expected to have the expertise to successfully complete the projects on their own, clients do not need to provide the support typical for an intern.
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 content">
                                        <span className="title">Can I hire the students after working with them?</span>
                                        <div className="content">
                                            Absolutely. Most students are enrolled in an academic program, and will be seeking either post-graduation employment or summer positions. You can reach out to any student you worked with who you were impressed by with job opportunities.
                                        </div>
                                    </div>
                                    <div className="col-xs-6 content">
                                        <span className="title">Who at the company engages and works with Versity?</span>
                                        <div className="content">
                                            Versity works directly with hiring managers across departments as well as human resources for company-wide campus recruiting programs. Many department heads use Versity to get work done on-demand while building a talent pipeline for sales, marketing, finance, operations, and just about every other department. Furthermore, since the students are highly skilled and have the experience or completed the prerequisite coursework to prepare them to execute these projects, companies do not need to provide managerial oversight or control.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/companies.js
 **/